/* unplugin-vue-components disabled */import { render } from "./FindScenicFood.vue?vue&type=template&id=55845b54&ts=true"
import script from "./FindScenicFood.vue?vue&type=script&lang=ts"
export * from "./FindScenicFood.vue?vue&type=script&lang=ts"

import "./FindScenicFood.vue?vue&type=style&index=0&id=55845b54&lang=scss"

import exportComponent from "D:\\taiwan-bike-map\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__